<template>
  <v-row>
    <v-col cols="12">
      <v-card>              
        <v-card-title class="text-h5">
          Buntinnehåll                
        </v-card-title>
        <v-card-subtitle>
          <v-row>
            <v-col cols="3">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="dates"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-card>
                  <v-card-text>
                    <div>            
                      <v-btn small text @click="setDates('last7days')">
                        Last 7 days
                      </v-btn>
                      <v-btn small text @click="setDates('thismonth')">
                        This month
                      </v-btn>
                      <v-btn small text @click="setDates('lastmonth')">
                        Last month
                      </v-btn>
                    </div>
                  </v-card-text>   
                  <v-date-picker v-model="dates" no-title scrollable range
                                 :first-day-of-week="1"
                                 locale="sv-SE"
                  >
                    <v-spacer />
                    <v-btn text color="primary" @click="resetDates()">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="saveDates()">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-card>
              </v-menu>
            </v-col>
            <v-col sm="2">
              <v-text-field v-model="customerId" 
                            outlined
                            label="Kundnummer"
                            type="number"                                               
                            class="input"                                   
                            append-outer-icon="mdi-magnify"
                            @keyup.enter="searchContent()"
                            @click:append-outer="searchContent()"
              />
            </v-col>
            <v-col sm="1" class="mt-3">
              <v-btn class="warning"
                     @click="reset"
              >
                Rensa
              </v-btn>
            </v-col>
          </v-row>
                
          <v-row>
            <v-col cols="1" class="mt-2 text-h6">
              Filter:
            </v-col>
            <v-col cols="2" class="mt-3">
              <v-btn-toggle v-model="filterStatus" class="ml-2" mandatory>
                <v-btn small value="true">
                  Öppen
                </v-btn>

                <v-btn small value="false">
                  Stängd
                </v-btn>

                <v-btn small value="all">
                  Alla
                </v-btn>
              </v-btn-toggle>
            </v-col>
            <v-col cols="1" class="mt-3">
              <v-btn-toggle v-model="filterTitel" class="ml-2">
                <v-btn small value="AB">
                  AB
                </v-btn>
                <v-btn small value="EX">
                  EX
                </v-btn>              
              </v-btn-toggle>
            </v-col>
            <v-col cols="2" class="ml-2">
              <v-text-field v-model="filterBundleId" 
                            outlined
                            :hide-details="true"
                            label="Buntnummer"
                            type="number"                                               
                            class="input"
                            append-icon="mdi-magnify"
                            @keyup="filter()"
                            @click:append="filter()"
              />
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-text>
          <div v-for="bundle in filterByStatus" :key="bundle.id">
            <bundle :bundle="bundle" />
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>

import api from '@/backend/adminapi'
import log from '@/logger'
import moment from 'moment'
import { cloneDeep, orderBy } from 'lodash'
import Bundle from '@/components/Bundle'
export default{
    name:'BundleContent',
    components:{Bundle},
    data() {
        return {        
            bundleContent:[],
            loading: false,
            customerId: undefined,
            filterStatus:'all',
            filterBundleId:'',
            filterOnId:false,
            filterTitel:'',
            dates: ['2022-08-07', '2022-08-07'],
            menu: false           
        }
    },
    computed:{
      dateRangeText() {
        return this.dates.join(' - ')
      },  
      filterByStatus(){
        var filteredBunt = cloneDeep(this.bundleContent)
        let self= this
        if(this.filterTitel !== undefined){
          switch(this.filterTitel){
            case 'AB':
            filteredBunt.forEach(bunt=>{                       
                bunt.returnReports = self.$options.filters.filterOutPaperByTitle(bunt.returnReports, [1,16])                                                            
              })        
            break
            case 'EX':
            filteredBunt.forEach(bunt=>{                       
              bunt.returnReports = self.$options.filters.filterOutPaperByTitle(bunt.returnReports, [2,4,8,32])                                                            
              })        
            break
            
          }
          
        }
        if(this.filterStatus === 'all' ){
          if(this.filterOnId){
            return filteredBunt.filter(p=> p.id.toString().includes(this.filterBundleId) ) 
          }
          return orderBy(filteredBunt,['id'],['desc'])
        }


        return orderBy(filteredBunt.filter(p=> p.open.toString() === this.filterStatus),['id'],['desc'])     
      }
    },
    watch: { 
      customerId: function() { // watch it                
         this.bundleContent = []
         this.loading = false     
         this.filterBundleId= ''
         this.filterOnId=false
      },      
    },
    mounted() {        
      this.setDates('last30days')
    },
    methods: {
        filter(){
          if(this.filterBundleId !== '' && this.filterBundleId !== undefined ){
            this.filterOnId = true
          }else{
            this.filterOnId = false
          }
        },  
        searchContent(){
          this.loading = true
          let self= this
          api.adminGetBundle(this.customerId,this.dates[0], this.dates[1])
            .then((resp) => {
                self.bundleContent = resp.data
                log.debug('Bundles:' + resp.data)
                self.loading = false
            }).catch((error) => {
                self.loading = false
                log.debug('Error uploading file:', error)
            })
        },
        reset(){
          this.customerId = undefined        
        },              
        setDates(period){
            var todayDate = new Date()
            this.oldDates = [...this.dates]
            var newDates = [2]
            if(period === 'today'){        
                newDates[0] = todayDate.toISOString().slice(0, 10)
                newDates[1] = todayDate.toISOString().slice(0, 10)      
                this.updateDates(newDates)
            }
            if(period === 'last7days'){
                newDates[0] = this.addDays(todayDate,-7).toISOString().slice(0, 10)
                newDates[1] = todayDate.toISOString().slice(0, 10)
                this.updateDates(newDates)
            }
            else if(period === 'lastmonth')
            {
                const d = moment(todayDate).subtract(1, 'months')
                newDates[0] = d.startOf('month').format('YYYY-MM-DD')
                newDates[1] = d.endOf('month').format('YYYY-MM-DD')
                this.updateDates(newDates)
            }
            else if(period === 'thismonth')
            {
                const d = moment(todayDate)
                newDates[0] = d.startOf('month').format('YYYY-MM-DD')
                newDates[1] = d.endOf('month').format('YYYY-MM-DD')
                this.updateDates(newDates)
            }
            else if(period === 'last30days')
            {
                newDates[0] = this.addDays(todayDate,-30).toISOString().slice(0, 10)
                newDates[1] = todayDate.toISOString().slice(0, 10)
                this.updateDates(newDates)
            }
        },
        updateDates(newDates){       
            this.$set(this.dates,0,newDates[0])
            this.$set(this.dates,1,newDates[1])      
        },
        addDays(date, days) {
            const copy = new Date(date) 
            copy.setDate(date.getDate() + days)
            return copy
        },
        resetDates(){
            this.menu = false
            this.updateDates(this.oldDates)
        },
        saveDates(){
            if(this.dates.length === 1){
                this.dates[1] = this.dates[0]
            }
            if(this.dates.some( (element) => element  === undefined)){
                let idx = this.dates.findIndex( (element) => element  === undefined) 
                if(idx === 0){
                    this.dates[0] = this.dates[1]
                }
                else if(idx === 1){
                    this.dates[1] = this.dates[0]
                }
            }
            this.$refs.menu.save(this.dates)     
        },
    }
}
</script>

<style scoped>
span {
    font-size: 1em;
}

.input >>> input[type="number"] {
  appearance: textfield;  
  -moz-appearance: textfield;  
}
.input >>> input::-webkit-outer-spin-button,
.input >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

</style>